import React, {Component} from 'react';

import Intro from './Intro';
import Test from './Test';
import Pause from 'components/Pause';
import strings from 'strings';

const subStages = [Intro, Test, Pause];

class PhonemeIsolation extends Component {
	constructor(props) {
		super(props);

		this.state = {
			currentStage: 0,
			currentStep: 0,
		};
	}

	componentWillReceiveProps(newProps) {
		const newState = {};
		let flag = false;
		if (newProps.currentStep !== this.props.currentStep) {
			newState.currentStep = newProps.currentStep;
			flag = true;
		}
		if (newProps.currentStage !== this.props.currentStage) {
			newState.currentStage = newProps.currentStage;
			flag = true;
		}
		if (flag) {
			this.setState(newState);
		}
	}

	render() {
		const {currentStage} = this.state;

		const CurrentSubStage = subStages[currentStage];

		return (
			<div className="lit-intro">
				<h2 className="lit-page-title">{strings.pi_testname}</h2>
				<CurrentSubStage
					onNextStep={this.handleNextSubstep}
					currentStep={this.state.currentStep}
					nextStep={this.props.nextStep}
					nextStage={this.props.nextStage}
					nextTest={this.props.nextTest}
					testKeyType={this.props.testKeyType}
					ageGroup={this.props.ageGroup}
					submitPhonemeIsolation={this.props.submitPhonemeIsolation}
					setReady={this.props.setReady}
					startTimer={this.props.startTimer}
					endTimer={this.props.endTimer}
				/>
			</div>
		);
	}
}

export default PhonemeIsolation;
